export const config = {
  API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT || 'https://dev.ai.api.getindigo.com/eval',
  AWS_REGION: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID || '',
  USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
  IDENTITY_POOL_ID: import.meta.env.VITE_IDENTITY_POOL_ID || '',
};